/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalController, LoadingController, AlertController, ToastController } from '@ionic/angular';
import { TermsComponent } from '@shared/components/terms/terms.component';
import { AuthenticationService } from '@shared/services/authentication.service';
import { UtilService } from '@shared/utils/util';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { UserModel } from '@shared/models/user.model';
import { LocationService } from '@shared/services/location.service';
import { GoogleAuth } from '@southdevs/capacitor-google-auth';
import { UserService } from '@shared/services/user.service';
import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';
import { Preferences } from '@capacitor/preferences';
import { HttpClient } from '@angular/common/http';
import { FcmService } from '@shared/services/fcm.service';
import { Router } from '@angular/router';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { Capacitor } from '@capacitor/core';
import { GoogleWebAuthService } from 'src/app/services/google-web-auth.service';
import { AppComponent } from 'src/app/app.component';
import { LoginSharedPage } from '../login-shared/login-shared.page';
import { PushNotifications } from '@capacitor/push-notifications';
import { FirebaseCrashlyticsService } from '@shared/services/firebase-crashlytics.service';
import { environment, webVersion } from 'src/environments/environment';
import { FacebookService } from '@shared/services/facebook.service';
import { FacebookUser } from '@shared/interfaces/facebook-user-interface';
import { FacebookLogin } from '@capacitor-community/facebook-login';
import { MatchService } from 'src/app/services/match.service';
import { SignInWithApple, SignInWithAppleResponse, SignInWithAppleOptions } from '@capacitor-community/apple-sign-in';
@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
  providers: [UtilService],
})
export class LoginPage implements OnInit {
  @ViewChild('webAuth') webAuth?: ElementRef<HTMLElement>;

  public showWebAuthentication = false;
  public showNativeWebLogin = false;
  public affiliateLandingHtml = '';

  public isNative: boolean = this.util.isNative();
  public isIos: boolean = true;
  public isIpad: boolean = false;
  public isTablet: boolean = false;
  public deviceInfo: any;
  public userData: any = {}; // Initialize with an empty object
  public imageFB: string = '';
  public processingAppleSignin: boolean = false;
  public processingGoogleSignin: boolean = false;
  public processingFacebookSignin: boolean = false;

  public userLoggedIn: boolean = false;
  constructor(
    private fcm: FcmService,
    private facebookService: FacebookService,
    private http: HttpClient,
    private userModel: UserModel,
    public analytics: AnalyticsService,
    private authenticationService: AuthenticationService,
    private modalCtrl: ModalController,
    public loadingCtrl: LoadingController,
    private util: UtilService,
    private alertCtrl: AlertController,
    public platform: Platform,
    public toastCtrl: ToastController,
    private translate: TranslateService,
    private userService: UserService,
    private locationService: LocationService,
    public firebaseCrashlytics: FirebaseCrashlyticsService,
    public router: Router,
    private matchService: MatchService,
    private googleWebAuth: GoogleWebAuthService,
  ) {
    this.util.initTranslate();
    this.userModel = new UserModel();
    this.isNative = this.util.isNative();
    this.isIos = !platform.is('android');
    this.isIpad = platform.is('ipad') || (platform.is('ios') && window.innerWidth >= 768);
    this.isTablet = this.isIpad || (platform.is('android') && window.innerWidth >= 768);
    this.initializeApp();
    //this.startVideo();
  }

  async ionViewWillEnter() {
    this.loadAffiliateLanding();
    this.userLoggedIn = localStorage.getItem('USER_LOGGED') ? true : false;

    // WEB: pré-carrega o GIS para que o clique em "Entrar com Google" seja síncrono
    // (o gapi.auth2 legado do plugin foi desligado pelo Google).
    if (!Capacitor.isNativePlatform()) {
      this.googleWebAuth.preload(environment.googleAuth.web).catch((e) => console.warn('GIS preload:', e));
    }

    this.util.initTranslate();

    if (localStorage.getItem('USER_LOGGED')) {
      this.router.navigateByUrl('/tabs/home');
      return;
    }

    Preferences.get({ key: 'USER_DATA' }).then((val) => {
      val = val.value ? JSON.parse(val.value) : null;
      this.userData = val;
      //this.ensureTerms();
    });

    // this.startVideo();
  }

  async ionViewDidEnter() {
    // Request push notification permission directly in login page for Android
    if (this.isNative && !this.userLoggedIn) {
      // Wait for UI to be ready
      setTimeout(async () => {
        try {
          // For Android, request permission directly here if not already requested
          if (this.platform.is('android')) {
            const deviceInfo = await Device.getInfo();
            const osVersion = parseInt(deviceInfo.osVersion);
            
            // Android 13+ requires explicit permission request
            if (osVersion > 12) {
              await this.registerNotifications();
            } else {
              // For Android <= 12, just try to register
              try {
                await PushNotifications.register();
                console.log('Push notifications registered for Android <= 12');
              } catch (error) {
                console.error('Error registering push notifications for Android <= 12:', error);
              }
            }
          } else {
            // For iOS, check if permission was already granted and register
            const permStatus = await PushNotifications.checkPermissions();
            if (permStatus.receive === 'granted') {
              await PushNotifications.register();
              console.log('Push notifications registered in login page (iOS)');
            } else if (permStatus.receive === 'prompt') {
              // If not yet asked, request it
              await this.registerNotifications();
            }
          }
        } catch (error) {
          console.error('Error handling push notification permission in login:', error);
        }
      }, 2000);
    }
  }

  ionViewWillLeave() {
  }

  registerNotifications = async () => {
    if (!Capacitor.isNativePlatform()) {
      console.log('Not native platform, skipping push notification registration');
      return;
    }

    try {
      let permStatus = await PushNotifications.checkPermissions();
      console.log('Push notification permission status:', permStatus.receive);

      // If permission is already granted, just register
      if (permStatus.receive === 'granted') {
        await PushNotifications.register();
        console.log('Push notifications registered (already granted)');
        return;
      }

      // If permission is denied, don't request again
      if (permStatus.receive === 'denied') {
        console.log('Push notification permission denied, skipping request');
        return;
      }

      // If permission is prompt (not yet asked), request it
      if (permStatus.receive === 'prompt' || permStatus.receive === 'prompt-with-rationale') {
        console.log('Requesting push notification permission...');
        // For Android, add a delay to ensure UI is ready
        if (this.platform.is('android')) {
          await new Promise(resolve => setTimeout(resolve, 500));
        } else {
          await new Promise(resolve => setTimeout(resolve, 300));
        }
        
        permStatus = await PushNotifications.requestPermissions();
        console.log('Push notification permission request result:', permStatus.receive);

        if (permStatus.receive === 'granted') {
          await PushNotifications.register();
          console.log('Push notifications registered (newly granted)');
        } else if (permStatus.receive === 'prompt-with-rationale' && this.platform.is('android')) {
          // Android specific: if rationale is needed, try again after a delay
          console.log('Android prompt-with-rationale, will retry after delay...');
          setTimeout(async () => {
            try {
              const retryStatus = await PushNotifications.requestPermissions();
              console.log('Android push notification retry result:', retryStatus.receive);
              if (retryStatus.receive === 'granted') {
                await PushNotifications.register();
                console.log('Push notifications registered after retry');
              }
            } catch (error) {
              console.error('Error retrying push notification permission:', error);
            }
          }, 2000);
        }
      }
    } catch (error) {
      console.error('Error registering push notifications:', error);
    }
  }

  private ensureTerms(): boolean {

    const tempURL = document.URL;
    const isDeepLink: boolean = tempURL.includes("referralUserId") || tempURL.includes("unsubscribe")

    if (AppComponent.isUnsubscribe || isDeepLink) {
      AppComponent.isUnsubscribe = false;
      return true;// No need to show terms for unsubscribe
    }

    if (this.userData != null && this.userData.termsAcceptedOn != null) {
      Preferences.set({ key: 'TERMS_ACCEPTED_ON', value: JSON.stringify(this.userData.termsAcceptedOn) }).then((_val) => {
        console.log('termsAcceptedOn saved to DB');
      });
      return true;
    }


    Preferences.get({ key: 'USER_DATA' }).then((val) => {
      val = val.value ? JSON.parse(val.value) : null;
      console.log('val inside ensureTerms: ' + val);

      if (val != null) {
        this.userData = val;
        console.log('val inside ensureTerms: ' + val);
        if (this.userData.termsAcceptedOn != null) {
          Preferences.set({ key: 'TERMS_ACCEPTED_ON', value: JSON.stringify(this.userData.termsAcceptedOn) }).then((_val) => {
            console.log('termsAcceptedOn saved to DB');
          });
          return true;
        } else {
          Preferences.get({ key: 'TERMS_ACCEPTED_ON' }).then((val) => {
            val = val.value ? JSON.parse(val.value) : null;
            if (val == null) {
              this.displayLoginShared();
              return false;
            } else {
              this.userData.termsAcceptedOn = val;
              Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) }).then((_val) => {
                console.log('userdata saved to DB');
              });
              return true;
            }
          });
        }
      } else {
        console.log('val inside ensureTerms is null. Will determine if termsAcceptedOn is set..');
        Preferences.get({ key: 'TERMS_ACCEPTED_ON' }).then((val) => {
          val = val.value ? JSON.parse(val.value) : null;
          console.log('termsAcceptedOn stored: ' + val);
          if (val == null) {
            this.displayTerms();
            return false;
          } else {
            return true;
          }
        });
      }

      return true; //!!!!!!!
    })

    return true;

  }

  private async displayLoginShared() {
    console.log('displayTerms..');
    const modal = this.modalCtrl.create({ component: LoginSharedPage, componentProps: { needsAcceptance: true } });
    (await modal).present();
  }

  private async displayTerms() {
    console.log('displayTerms..');
    const modal = this.modalCtrl.create({ component: TermsComponent, componentProps: { needsAcceptance: true } });
    (await modal).present();

  }


  async ngOnInit() {
    this.getDevice();
  }


  initializeApp() {
    this.platform.ready().then(async () => {
      try {
        await FacebookLogin.initialize({ appId: '990402335013238' });
        console.log('Facebook Login inicializado com sucesso');
      } catch (error) {
        console.error('Erro ao inicializar Facebook Login:', error);
      }
    })
  }

  async getDevice() {
    const device = await Device.getInfo();
    if (this.util.isNative()) {
      this.deviceInfo = {
        manufacturer: device.manufacturer,
        model: device.model,
        version: device.osVersion,
        platform: device.platform,
        uuid: (await Device.getId()).identifier,
        appVersion: (await App.getInfo()).version,
      };

    } else {
      // Browser
      this.deviceInfo = {
        manufacturer: device.manufacturer,
        model: device.model,
        version: device.osVersion,
        platform: device.platform,
        uuid: (await Device.getId()).identifier,
        appVersion: webVersion
      }

    }
    this.userModel.device = this.deviceInfo
  }

  async openModal() {
    const modal = await this.modalCtrl.create({
      component: TermsComponent,
    });
    modal.present();

    const { data: _data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      //alert(`Hello, ${data}!`);
    }
  }

  public startVideo() {
    console.log(this.isNative);
    console.log(this.isIos);

    if (!localStorage.getItem('USER_LOGGED')) {
      try {
        const videoElement = document.querySelector('video');
        if (videoElement) {
          videoElement.autoplay = true;
          const promise = videoElement.play();
          if (promise !== undefined) {
            promise.then(() => {
              console.log('Autoplay started!');
            }).catch(error => {
              console.log('Autoplay prevented:', error);
              throw new Error('Error in autoplay handling: ' + error.message);
            });
          }
        }

        console.log('Video started playing successfully');
      } catch (error) {
        console.error('Video play error:', error);
      }
    }

  }

  appleSignin() {
    this.processingAppleSignin = true;

    const options: SignInWithAppleOptions = {
      clientId: 'com.leftyapp',
      redirectURI: 'https://app.fyradating.com/',
      scopes: 'email name',
      state: '12345',
      nonce: 'nonce',
    };

    SignInWithApple.authorize(options)
      .then(async (loginSuccess: SignInWithAppleResponse) => {

        this.loadingCtrl.create({
          message: this.translate.instant('msgOneMomentPlease'),
        });

        let userDataLocal: any = {
          appleUser: loginSuccess.response.user,
        }

        if (loginSuccess.response.givenName != undefined && loginSuccess.response.givenName != null && loginSuccess.response.givenName != null) {
          const _fullName = loginSuccess.response.givenName + loginSuccess.response.familyName;
          userDataLocal.firstName = loginSuccess.response.givenName;
          userDataLocal.lastName = loginSuccess.response.familyName;
        }

        userDataLocal.authorizationCode = loginSuccess.response.authorizationCode;
        userDataLocal.identityToken = loginSuccess.response.identityToken;

        if (loginSuccess.response.email !== '') {
          userDataLocal.email = loginSuccess.response.email;
          localStorage.setItem('USER_LOGGED', 'true')
          Preferences.set({ key: 'USER_DATA_APPLE', value: userDataLocal }).then((_val) => {
            console.log('userdataapple stored');
          });

        } else {
          await Preferences.get({ key: 'USER_DATA_APPLE' }).then((val) => {
            val = val.value ? JSON.parse(val.value) : null;
            if (val != null) {
              userDataLocal = val;
              localStorage.setItem('USER_LOGGED', 'true')
            }
            console.log('userdataapple that was stored: ' + JSON.stringify(userDataLocal));
          });
        }
        Preferences.get({ key: 'LAST_LOCATION' }).then((val) => {
          val = val.value ? JSON.parse(val.value) : null;
          let location = val;
          const teleportationLocation = this.locationService.getTeleportationLocation();
          if (teleportationLocation != null) {
            location = teleportationLocation;
          }


          // Referral only on signup (createConfirmed below), not returning-user login.
          this.userService.upsertSoul(userDataLocal, location, false, false, true)
            .subscribe(
              {
                next: async (data) => {

                  if (data == '{not ok}') {
                    console.log('upsert subscribe entered');
                    console.log('data returned from upsert: ' + data);
                    if (userDataLocal.email != undefined && userDataLocal.email != null) {

                      const alert = this.alertCtrl.create({
                        subHeader: this.translate.instant('createNewAccount'),
                        message: this.translate.instant('userWithEmailNotFound') + ' <b>' + userDataLocal.email + '</b>. ' + this.translate.instant('wouldYouLikeToCreateNew') + ' <a href="https://fyradating.com/user-manual/#sign-in-with-apple">' + this.translate.instant('tryingToAccessExisting') + '</a>?',
                        buttons: [
                          {
                            text: this.translate.instant('cancel'),
                            handler: () => {
                              this.loadingCtrl.dismiss();
                              this.processingAppleSignin = false;
                            }
                          },
                          {
                            text: this.translate.instant('confirm'),
                            handler: () => {
                              userDataLocal.createConfirmed = true;
                              this.attachReferralUserId(userDataLocal);
                              this.userService.upsertSoul(userDataLocal, location, false, false, true).subscribe(
                                {
                                  next: async (data) => {
                                    console.log('createConfirmed upsert subscribe entered');
                                    console.log('data returned from createConfirmed upsert: ' + data);

                                    if (data == '{not ok}') {
                                      console.log('createConfirmed Upsert error: ');
                                      return;
                                    }

                                    console.log("============USER APPLE CREATED=========");
                                    console.log(this.userData);

                                    this.userData = JSON.parse(data);

                                    this.registerLoginEvents();
                                    this.saveProfile(null);

                                  },
                                  error: (erro) => {
                                    console.log('Upsert error: ' + JSON.stringify(erro.toString()));
                                    this.loadingCtrl.dismiss();
                                    this.util.showToastUnableToConnect(this.toastCtrl);
                                    this.processingAppleSignin = false;
                                  }
                                }
                              );
                              return;
                            }
                          }
                        ]
                      });
                      (await alert).present();

                    } else { // No email was sent to server. User already signed in on device and account not found in our server
                      const alert = this.alertCtrl.create({
                        subHeader: this.translate.instant('accountNotFoundOnVeggly'),
                        message: this.translate.instant('ifYouWouldLikeNewStopAppleId'),
                        buttons: [
                          {
                            text: 'OK',
                            handler: () => {
                              //this.loader.dismiss();
                            }
                          }
                        ]
                      });
                      (await alert).present();
                    }

                  } else {

                    const resultJSON: any = JSON.parse(data);
                    if (resultJSON.login != undefined && resultJSON.login != null && resultJSON.login == 'invalid') {
                      this.showModalAlert(this.translate.instant('invalidLogin'));
                      this.processingAppleSignin = false;
                      return;
                    } else {

                      this.userData = resultJSON;
                      this.userModel = this.userData;

                      this.registerLoginEvents();
                      this.saveProfile(null);
                    }
                  }
                },
                error: (erro) => {
                  console.log(erro);
                  this.processingAppleSignin = false;
                }
              }
            )
        },
          error => {
            console.error(JSON.stringify(error))
            console.log(JSON.stringify(error))
            this.processingAppleSignin = false;
          });

      }, (reason: any) => {
        console.log(reason);
        this.processingAppleSignin = false;
      })
      .catch(error => {
        console.error(JSON.stringify(error))
        console.log(JSON.stringify(error))
        this.processingAppleSignin = false;
      });


  }

  async appleSigninNew() {
    // const loading = await this.loadingCtrl.create({
    //   message: 'Dismissing after 3 seconds...',
    //   duration: 3000,
    // });
    // loading.present();

    const options: SignInWithAppleOptions = {
      clientId: 'com.leftyapp',
      redirectURI: 'https://app.fyradating.com/',
      scopes: 'email name',
      state: '12345',
      nonce: 'nonce',
    };

    SignInWithApple.authorize(options)
      .then((_result: SignInWithAppleResponse) => {

      })
      .catch(_error => {
        // Handle error
      });

  }

  async showLoading(message: string) {
    const loading = await this.loadingCtrl.create({
      message: message,
      duration: 3000,
      translucent: true,

      backdropDismiss: true
    });

    loading.present();
  }

  async googleSignIn() {
    // WEB: gapi.auth2 foi desligado pelo Google → usa GIS (ID token flow) → googleIdToken,
    // que é o que o backend valida. Nativo segue no plugin.
    if (!Capacitor.isNativePlatform()) {
      await this.googleSignInWeb();
      return;
    }

    this.processingGoogleSignin = true;

    try {
      console.log('Iniciando login do Google...');

      let clientId: string = '';

      if (!Capacitor.isNativePlatform()) {
        clientId = environment.googleAuth.web;
        console.log('Plataforma: Web, Client ID:', clientId);
      } else if (this.isIos) {
        clientId = environment.googleAuth.ios;
        console.log('Plataforma: iOS, Client ID:', clientId);
      } else {
        clientId = environment.googleAuth.android;
        console.log('Plataforma: Android, Client ID:', clientId);
      }

      // Verificar se o clientId está definido
      if (!clientId) {
        throw new Error('Google Auth Client ID não encontrado');
      }

      console.log('Inicializando Google Auth...');
      await GoogleAuth.initialize({
        clientId: clientId,
        scopes: ['profile', 'email'],
        grantOfflineAccess: true,
      });
      console.log('Google Auth inicializado com sucesso');

      console.log('Tentando fazer login...');
      const googleUser = await GoogleAuth.signIn({ scopes: ['profile', 'email'], serverClientId: environment.googleAuth.web });
      console.log('Google Authentication Result:', googleUser);
      // Handle authentication success
      if (googleUser.email == undefined || googleUser.email == null || googleUser.email == '') {
        this.showModalAlert(this.translate.instant('googleNoEmail'));
        this.processingGoogleSignin = false;
        return;
      }

      this.userData = {
        email: googleUser.email
      };

      if ((googleUser as any).googleUserId != null) {
        this.userData.googleUserId = (googleUser as any).googleUserId
      }
      if (googleUser.name != null) {
        this.userData.displayName = googleUser.name
      }
      if (googleUser.givenName != null) {
        this.userData.firstName = googleUser.givenName
      }
      if (googleUser.familyName != null) {
        this.userData.lastName = googleUser.familyName
      }
      if (googleUser.authentication.refreshToken != null) {
        this.userData.googleRefreshToken = googleUser.authentication.refreshToken
      }
      if (googleUser.serverAuthCode != null) {
        this.userData.googleServerAuthCode = googleUser.serverAuthCode
      }

      if (googleUser.authentication.accessToken != null) {
        this.userData.googleAccessToken = googleUser.authentication.accessToken
      }
      if (googleUser.authentication.idToken != null) {
        this.userData.googleIdToken = googleUser.authentication.idToken
      }

      console.log('Dados do usuário processados:', this.userData);
      this.registerLoginEvents();
      this.saveProfile(null);

    } catch (error) {
      console.error('Google Authentication Error:', error);

      // Tratamento específico para diferentes tipos de erro
      let errorMessage = 'Erro desconhecido';

      if (error instanceof Error) {
        errorMessage = error.message;
      } else if (typeof error === 'string') {
        errorMessage = error;
      } else if (error && typeof error === 'object') {
        errorMessage = (error as any).message || JSON.stringify(error);
      }

      // Logs específicos para debugging em produção
      console.error('Google Auth Error Details:', {
        message: errorMessage,
        platform: Capacitor.isNativePlatform() ? (this.isIos ? 'iOS' : 'Android') : 'Web',
        clientId: environment.googleAuth[Capacitor.isNativePlatform() ? (this.isIos ? 'ios' : 'android') : 'web'],
        timestamp: new Date().toISOString()
      });

      this.showModalAlert(errorMessage);
      this.processingGoogleSignin = false;
    }
  }

  /**
   * Login Google na WEB via Google Identity Services (ID token flow).
   * Obtém o JWT (googleIdToken, validado no backend) e decodifica email/nome/sub para
   * manter o mesmo payload do fluxo nativo. Substitui o gapi.auth2 desligado pelo Google.
   */
  private async googleSignInWeb() {
    this.processingGoogleSignin = true;
    try {
      const idToken = await this.googleWebAuth.signInGetIdToken(environment.googleAuth.web);
      const claims = this.googleWebAuth.decodeIdToken(idToken);

      if (!claims || claims.email == null || claims.email === '') {
        this.showModalAlert(this.translate.instant('googleNoEmail'));
        this.processingGoogleSignin = false;
        return;
      }

      this.userData = { email: claims.email };
      this.userData.googleIdToken = idToken;
      if (claims.sub != null) {
        this.userData.googleUserId = claims.sub;
      }
      if (claims.name != null) {
        this.userData.displayName = claims.name;
      }
      if (claims.given_name != null) {
        this.userData.firstName = claims.given_name;
      }
      if (claims.family_name != null) {
        this.userData.lastName = claims.family_name;
      }

      this.registerLoginEvents();
      this.saveProfile(null);
    } catch (error) {
      console.error('Google Authentication Error (web):', error);
      this.showModalAlert(((error as any).message || 'Unknown Error'));
      this.processingGoogleSignin = false;
    }
  }

  async loginWithFB() {
    this.processingFacebookSignin = true;
    const loading = await this.loadingCtrl.create({
      message: this.translate.instant('pleaseWait'),
      duration: 3000,
    });

    try {
      loading.present();

      console.log('Iniciando login do Facebook...');

      // Primeiro, inicializar o Facebook se necessário
      try {
        await FacebookLogin.initialize({ appId: '990402335013238' });
        console.log('Facebook inicializado com sucesso');
      } catch (initError) {
        console.log('Facebook já inicializado ou erro de inicialização:', initError);
      }

      // Tentar fazer login
      const { token, type } = await this.facebookService.login();
      console.log('Access Token obtido:', token ? 'Sim' : 'Não', 'tipo:', type);

      if (token) {
        // Obter dados do usuário
        const facebookUser: FacebookUser = await this.facebookService.getUserData(token, type);
        console.log('User Data:', facebookUser);

        this.userData = facebookUser;
        this.userData.facebookAccessToken = token;
        this.userData.facebookLoginType = type;
        this.registerLoginEvents();

        if (facebookUser?.picture?.data?.url) {
          this.saveProfile(facebookUser.picture.data.url);
        } else {
          this.saveProfile(null);
        }
      } else {
        console.error('Falha no login do Facebook - sem access token');
        this.showModalAlert('Facebook login error. Try again.');
      }
    } catch (error) {
      console.error('Erro detalhado no login do Facebook:', error);
      this.showModalAlert(((error as any).message || 'Unknown Error'));
    } finally {
      this.processingFacebookSignin = false;
      loading.dismiss();
    }
  }




  private async saveProfile(localPicture: any) {
    console.log('=== saveProfile iniciado ===');
    console.log('userData:', this.userData);

    const lastLocation = await Preferences.get({ key: 'LAST_LOCATION' });
    let location = lastLocation?.value ? JSON.parse(lastLocation.value) : { type: 'Point', coordinates: [environment.locationDefault.coordinates[0], environment.locationDefault.coordinates[1]] };
    const teleportationLocation = this.locationService.getTeleportationLocation();
    if (teleportationLocation != null) {
      location = teleportationLocation;
    }

    console.log('location:', location);
    console.log('environment.mainServer:', environment.mainServer);

    // Retrieve and add FCM token to userData before sending to server
    console.log('=== Attempting to retrieve FCM token ===');
    let tokenValue = null;

    // Try Preferences first
    const fcmToken = await Preferences.get({ key: 'TOKEN' });
    if (fcmToken && fcmToken.value) {
      tokenValue = fcmToken.value;
      console.log('FCM token found in Preferences:', tokenValue);
    } else {
      console.log('No FCM token in Preferences, checking localStorage');
      // Fallback to localStorage
      const localToken = localStorage.getItem('TOKEN');
      if (localToken) {
        tokenValue = localToken;
        console.log('FCM token found in localStorage:', tokenValue);
      } else {
        console.log('No FCM token found in either storage location');
      }
    }

    if (tokenValue) {
      this.userData.token = tokenValue;
      console.log('FCM token successfully added to userData');
      console.log('userData object before upsertSoul:', JSON.stringify(this.userData));
    }

    // Same as LoginSharedPage: stamp pending/URL referral on Google/FB so the
    // referrer is credited on create. Backend ignores referral on returning login.
    this.attachPendingReferralUserId(this.userData);
    this.userService
      .upsertSoul(this.userData, location, false, false, true)
      .subscribe(
        {
          next: async (data) => {
            console.log('=== upsertSoul sucesso ===');
            console.log('Resposta do servidor:', data);
            if (data != '{not ok}') {
              this.userModel = JSON.parse(data);

              // Send image to Server
              const serverPicture = this.userData.picture0;

              if (localPicture != null && serverPicture == null) {
                this.userData = JSON.parse(data);
                this.http.get(localPicture, { responseType: 'blob' })
                  .subscribe(
                    {
                      next: (response: Blob) => {
                        const fileReader = new FileReader();
                        const zoneOriginalInstance = (fileReader as any).__zone_symbol__originalInstance;
                        const reader = zoneOriginalInstance || fileReader;

                        reader.onloadend = async () => {
                          const uploadImageFB = this.setFirstPicture();
                          if (uploadImageFB) {
                            this.imageFB = reader.result as string;
                            const filename: string = 'picture' + 0;
                            this.userService
                              .uploadImage64(this.imageFB, this.userModel, filename)
                              .subscribe(
                                {
                                  next: async (data) => {
                                    this.analytics.registerEvent(AnalyticsService.signUpComplete, true);
                                    this.analytics.registerEvent(AnalyticsService.loginOrSignUpCompl, true);
                                    this.userModel.filename = { '$oid': data };
                                    this.userModel.picture0 = { '$oid': data };
                                    await this.storeUserLocally();
                                  },
                                  error: (_err) => {
                                    //alert('uploadImage error: ' + JSON.stringify(err));
                                  }
                                }
                              )
                          } else {
                            this.analytics.registerEvent(AnalyticsService.signUpComplete, true);
                            this.analytics.registerEvent(AnalyticsService.loginOrSignUpCompl, true);
                            await this.storeUserLocally();
                          }

                        }


                        reader.readAsDataURL(response);

                      },
                      error: (erro) => {
                        //alert("Usuário ou Senha inválido(s)!");
                        console.log(erro)
                      }
                    }
                  )
              } else {
                this.userData = JSON.parse(data);
                await this.storeUserLocally();
              }
            }
          },
          error: (erro) => {
            console.log('=== upsertSoul erro ===');
            console.log('Erro completo:', erro);
            console.log('Status:', erro.status);
            console.log('Mensagem:', erro.message);
            console.log('URL:', erro.url);
            //alert("Usuário ou Senha inválido(s)!");
            console.log(erro)
            this.processingGoogleSignin = false;
            this.processingFacebookSignin = false;
            this.processingAppleSignin = false;
          }
        }
      )



  }

  setFirstPicture() {
    let picnum: number;
    let picCount: number = 0;
    const data2: any = this.userModel
    for (picnum = 0; picnum < 9; picnum++) {
      const aPic: string = "picture" + picnum;
      if (data2[aPic]) {
        picCount++;
      }
    }
    if (picCount == 0) {
      return true;
    }
    return false
  }




  async showModalAlert(message: string) {
    const alert = await this.alertCtrl.create({
      subHeader: message,
      buttons: [
        {
          text: 'OK',
          handler: () => { }
        }
      ]
    });

    await alert.present();
  }

  showWelcomeBackMsg() {
    if (this.userModel.wasOnHibernate != null) {
      this.showModalAlert(this.translate.instant('welcomeBackFromHibernate'));
      delete this.userModel.wasOnHibernate;

      Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userModel) }).then(() => {
        console.log('login.showWelcomeBackMsg: saved user without the wasOnHibernate');
      });
    }
  }

  private async storeUserLocally() {
    // Mesmo usuário logando de novo: restaura teletransporte (backup primeiro, depois userData do servidor)
    const userToRestore = this.userData || this.userModel;
    await this.locationService.restoreTeleportationFromBackup(userToRestore);
    if (!this.locationService.getTeleportationLocation()) {
      await this.locationService.restoreTeleportationFromUserData(userToRestore);
    }
    const teleportLoc = this.locationService.getTeleportationLocation();
    if (teleportLoc) {
      this.userModel.location = teleportLoc;
      this.userModel.usingTeleportation = true;
    }

    // userModel é a fonte canônica pós-login (inclui hash, _id e mutações de upload de imagem).
    // Sincroniza userData e persiste USER_DATA numa única escrita atômica.
    this.userData = { ...this.userModel };
    console.log('Stored UserData = ' + JSON.stringify(this.userData));
    await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) });

    console.log('Will set UserService.loggedOut to false. Current value: ' + UserService.loggedOut);
    UserService.loggedOut = false;
    this.processingGoogleSignin = false;
    this.processingFacebookSignin = false;
    this.processingAppleSignin = false;
    this.restartMatchService();
    localStorage.setItem('USER_LOGGED', 'true');
    await Preferences.set({ key: 'USER_LOGGED', value: 'true' });
    this.showWelcomeBackMsg();

    if (this.userData.interest2 != null) {
      this.router.navigateByUrl('/tabs/home');
    } else {
      this.router.navigateByUrl('/tabs/my-profile-display');
    }
  }

  registerLoginEvents() {
    // Your logic for registering login events
    Preferences.get({ key: 'USER_DATA' }).then((val: any) => {
      val = val.value ? JSON.parse(val.value) : null;
      if (this.userService.checkUserHasPicture(val)) {
        this.analytics.registerEvent(AnalyticsService.loginOrSignUpCompl, true);
        if (val.sign_up_compl_ok)
          this.analytics.registerEvent(AnalyticsService.loginOrSignUpComplOk, true);
        if (val.valuable_user_1d)
          this.analytics.registerEvent(AnalyticsService.loginOrSignUpValuable1d, true);
        if (val.valuable_user)
          this.analytics.registerEvent(AnalyticsService.loginOrSignUpValuable, true);
      }
    })
  }

  showJoinOptions() {
    this.showWebAuthentication = true;
    setTimeout(() => {
      this.webAuth?.nativeElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  hideJoinOptions() {
    this.showWebAuthentication = false;
  }

  showExistingLogin() {
    this.showNativeWebLogin = true;
  }

  hideExistingLogin() {
    this.showNativeWebLogin = false;
  }

  private loadAffiliateLanding() {
    const referralUserId = this.userService.extractReferralUserId(window.location.href);
    if (!referralUserId) {
      return;
    }
    // Keep default copy visible immediately; replace only if custom HTML arrives.
    this.userService.getAffiliateLanding(referralUserId).subscribe({
      next: (landing: any) => {
        const html = (landing?.html || '').trim();
        // Prefer an explicit backend flag; fall back to stock-copy heuristic.
        // Pass raw HTML through [innerHTML] so Angular's sanitizer stays on
        // (do not bypassSecurityTrustHtml on affiliate-controlled content).
        const useTemplateDefault =
          landing?.isDefault === true || this.isStockDefaultLandingHtml(html);
        this.affiliateLandingHtml = useTemplateDefault ? '' : html;
      },
      error: () => {
        this.affiliateLandingHtml = '';
      }
    });
  }

  /**
   * Prefer `landing.isDefault` from the API. EN-only text heuristic is a
   * best-effort fallback while some routes omit the flag — localized stock
   * HTML will not match and should be fixed by sending `isDefault: true`.
   * Angular sanitizes [innerHTML] (no bypassSecurityTrustHtml).
   */
  private isStockDefaultLandingHtml(html: string): boolean {
    if (!html) {
      return true;
    }
    const text = html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
    return text.includes('dating with intention')
      && text.includes('meet someone who wants something real')
      && text.includes('fyra brings thoughtful people together')
      && text.length < 200;
  }

  async openProfile() {
    this.router.navigateByUrl('/tabs/home');
  }
  async openDefaultLogin() {
    this.router.navigateByUrl('/default-login');
  }

  async openSignup() {
    const referralUserId = this.resolvePendingReferralUserId();
    this.router.navigate(['/signup-with-email'], {
      queryParams: referralUserId ? { referralUserId } : {}
    });
  }

  /** URL query (web) or pending attribution (native deep link / prior capture). */
  private resolvePendingReferralUserId(): string | null {
    const fromUrl = this.userService.extractReferralUserId(window.location.href);
    const fromAttribution = this.userService.getPendingAcquisitionAttribution()?.['referralUserId'];
    return fromUrl || fromAttribution || null;
  }

  /** Stamp referral on Google/FB upsert payload (parity with LoginSharedPage). */
  private attachPendingReferralUserId(userData: Record<string, unknown>): void {
    if (userData?.['referralUserId']) {
      return;
    }
    const referralUserId = this.resolvePendingReferralUserId();
    if (referralUserId) {
      userData['referralUserId'] = referralUserId;
    }
  }

  /** Apple native createConfirmed only — credits referrer after explicit create. */
  private attachReferralUserId(userData: Record<string, unknown>): void {
    // Only after the user confirms account creation (Apple createConfirmed).
    // Apple Sign-In is native-only (login.page.html isIos && isNative).
    // Pending attribution is filled from App.getLaunchUrl / appUrlOpen on native.
    if (!userData?.['createConfirmed']) {
      return;
    }
    this.attachPendingReferralUserId(userData);
  }


  private restartMatchService() {
    this.matchService.restartRefresh();
  }
}